var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1996_41808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47301 0 0 4.4725 0 10C0 15.5269 4.4725 20 10 20C15.527 20 20 15.5275 20 10C20 4.47301 15.5275 0 10 0ZM10 18.6046C5.25539 18.6046 1.39535 14.7446 1.39535 10C1.39535 5.25535 5.25539 1.39535 10 1.39535C14.7446 1.39535 18.6046 5.25535 18.6046 10C18.6046 14.7446 14.7446 18.6046 10 18.6046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70413 12.6533C9.15127 12.6533 8.70374 13.114 8.70374 13.6668C8.70374 14.2066 9.13811 14.6804 9.70413 14.6804C10.2701 14.6804 10.7176 14.2066 10.7176 13.6668C10.7176 13.114 10.2569 12.6533 9.70413 12.6533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87517 4.97925C8.09814 4.97925 7.28204 6.03233 7.28204 6.74311C7.28204 7.25647 7.71642 7.49343 8.07181 7.49343C8.78263 7.49343 8.49306 6.47983 9.83568 6.47983C10.4938 6.47983 11.0204 6.76944 11.0204 7.37495C11.0204 8.08573 10.2832 8.49378 9.84884 8.86233C9.46708 9.19136 8.96693 9.73108 8.96693 10.8631C8.96693 11.5476 9.15122 11.745 9.69087 11.745C10.3358 11.745 10.4675 11.4555 10.4675 11.2053C10.4675 10.5208 10.4806 10.126 11.2046 9.55995C11.56 9.28355 12.6788 8.38843 12.6788 7.15112C12.6788 5.91382 11.56 4.97925 9.87517 4.97925Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1996_41808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.74408652568d664bf6c01dd8b77d1ea0.svg";
export { ForwardRef as ReactComponent };